<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="6">
                    <ValidationProvider name="local_name" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('local_name')">
                            <b-form-input v-model="formData.local_name" :state="errors[0] ? false : null"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <ValidationProvider name="local_surname" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('local_surname')">
                            <b-form-input v-model="formData.local_surname" :state="errors[0] ? false : null"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center">
                <b-button variant="primary" @click="updateForm" :disabled="formProcess">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    // Services
    import PersonService from "@/services/PersonService";
    // Other
    import {ValidationObserver, ValidationProvider} from 'vee-validate'

    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            }
        },
        created() {
            this.formId = this.studentProgram.id;
            this.formData = {
                local_name: this.studentProgram.local_name,
                local_surname: this.studentProgram.local_surname,
                email: this.studentProgram.email,
                gender: this.studentProgram.gender,
                name: this.studentProgram.name,
                national_id: this.studentProgram.national_id,
                nationality_code: this.studentProgram.nationality_code,
                surname: this.studentProgram.surname,
                type: "student",
            }
        },
        mounted() {
            this.$refs.formModalValidate.reset();
        },
        data() {
            return {
                formId: null,
                formData: {},
                formProcess: false
            }
        },
        methods: {
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formProcess = true;
                    PersonService.update(this.studentProgram.user_id, this.formData)
                                         .then(response => {
                                             this.$emit('updateFormSuccess', true);
                                             this.$toast.success(this.$t('api.' + response.data.message));
                                         })
                                         .catch((e) => {
                                             this.showErrors(e, this.$refs.formModalValidate)
                                         })
                                         .finally(() => {
                                             this.formProcess = false
                                         })
                }
            }
        }
    }
</script>

